import {
	ADMIN_INIT_NEW_USER,
	ADMIN_RESET_FOCUS_USER,
	API_ADMIN_DELETE_USER,
	API_ADMIN_GET_USER,
	API_ADMIN_PATCH_USER,
	SET_SESSION_CENTER_USER,
	API_ADMIN_GET_ALL_USER,
	API_ADMIN_POST_USER,
	SET_NURSE_MODE_USER,
	API_GET_CONNECTED,
	API_PATCH_TOGGLE_NURSE_HELP,
	API_GET_NURSE_HELP,
	API_GET_CONNECTED_SECRETARIES,
	API_PATCH_TOGGLE_NEED_HELP,
	API_GET_NEED_HELP,
	TOGGLE_HELPFOLDERS_MY_CENTER,
	API_ADMIN_GET_SAMPLERS_USER,
	API_PATCH_SOUND_NOTIFICATION,
	API_PATCH_TEL_FOR_TVSEC,
} from "../actions/user";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_ADMIN_GET_USER]: {
		default: (user) => `/users/${user.id}`,
		v2: (user) => `/user/${user.id}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_ALL_USER]: {
		default: "/admin/users",
		v2: "/user/admin/users",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_POST_USER]: {
		default: "/admin/users",
		v2: "/user/admin/user",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_PATCH_USER]: {
		default: (user) => `/admin/users/${user.id}`,
		v2: (user) => `/user/${user.id}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_DELETE_USER]: {
		default: (user) => `/admin/users/${user.id}`,
		v2: (user) => `/user/admin/user/${user.id}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CONNECTED]: {
		default: "/users/connected/",
		// v2: "/users/connected/",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_CONNECTED_SECRETARIES]: {
		default: "/users/helpNurseConnected/",
		v2: "/user/users/help-nurse-connected",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_NURSE_HELP]: {
		default: "/users/nurseHelp/",
		// v2: "/users/nurseHelp/",
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_TOGGLE_NURSE_HELP]: {
		default: "/users/nurseHelp/",
		// v2: "/users/nurseHelp/",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_NEED_HELP]: {
		default: "/users/needhelp/",
		// v2: "/users/needhelp/",
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_TOGGLE_NEED_HELP]: {
		default: "/users/needhelp/",
		// v2: "/users/needhelp/",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_SAMPLERS_USER]: {
		default: "/admin/users/samplers/",
		v2: "/admin/users/samplers/",
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_SOUND_NOTIFICATION]: {
		default: "/users/sound",
		// v2: "/users/sound",
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_TEL_FOR_TVSEC]: {
		default: "/users/tel",
		// v2: "/users/tel",
		currentClient: DEFAULT_CLIENT,
	},
}

export function adminGetUser(user) {
	const version = getVersion(API_ADMIN_GET_USER);
	const url = typeof version.path === 'function' ? version.path(user) : version.path;
	return {
		type: API_ADMIN_GET_USER,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
			},
		},
	};
}

export function adminGetAllUsers() {
	const version = getVersion(API_ADMIN_GET_ALL_USER);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_GET_ALL_USER,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
			},
		},
	};
}

export function adminPostUser(user) {
	const version = getVersion(API_ADMIN_POST_USER);
	const url = typeof version.path === 'function' ? version.path(user) : version.path;
	return {
		type: API_ADMIN_POST_USER,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
				method: "POST",
				data: user,
			},
		},
	};
}

export function adminPatchUser(user) {
	const version = getVersion(API_ADMIN_PATCH_USER);
	const url = typeof version.path === 'function' ? version.path(user) : version.path;
	return {
		type: API_ADMIN_PATCH_USER,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
				method: "PATCH",
				data: user,
			},
		},
	};
}

export function adminDeleteUser(user) {
	const version = getVersion(API_ADMIN_DELETE_USER);
	const url = typeof version.path === 'function' ? version.path(user) : version.path;
	return {
		type: API_ADMIN_DELETE_USER,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
				method: "DELETE",
			},
		},
	};
}

export function initNewUser() {
	return {
		type: ADMIN_INIT_NEW_USER,
	};
}

export function resetFocusUser() {
	return {
		type: ADMIN_RESET_FOCUS_USER,
	};
}

export function setNurseMode(type) {
	return {
		type: SET_NURSE_MODE_USER,
		payload: type,
	};
}

export function setSessionCenter(center, box, themeHospital) {
	return {
		type: SET_SESSION_CENTER_USER,
		payload: { center, box, themeHospital },
	};
}
export function toggleHelpFolderOfMyCenter() {
	return {
		type: TOGGLE_HELPFOLDERS_MY_CENTER,
	};
}

export function getConnectedUsers() {
	const version = getVersion(API_GET_CONNECTED);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_CONNECTED,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
			},
		},
	};
}

export function getHelpNurseConnectedSecretaries() {
	const version = getVersion(API_GET_CONNECTED_SECRETARIES);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_CONNECTED_SECRETARIES,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
			},
		},
	};
}

export function getNurseHelp() {
	const version = getVersion(API_GET_NURSE_HELP);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_NURSE_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
			},
		},
	};
}

export function toggleNurseHelp() {
	const version = getVersion(API_PATCH_TOGGLE_NURSE_HELP);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_PATCH_TOGGLE_NURSE_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
				method: "PATCH",
			},
		},
	};
}

export function getNeedHelp() {
	const version = getVersion(API_GET_NEED_HELP);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_NEED_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
			},
		},
	};
}

export function toggleNeedHelp() {
	const version = getVersion(API_PATCH_TOGGLE_NEED_HELP);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_PATCH_TOGGLE_NEED_HELP,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
				method: "PATCH",
			},
		},
	};
}

export function adminGetAllSamplers() {
	const version = getVersion(API_ADMIN_GET_SAMPLERS_USER);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_GET_SAMPLERS_USER,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
			},
		},
	};
}

export function setSoundNotification(sound) {
	const version = getVersion(API_PATCH_SOUND_NOTIFICATION);
	const url = typeof version.path === 'function' ? version.path({ sound }) : version.path;
	return {
		type: API_PATCH_SOUND_NOTIFICATION,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
				method: "PATCH",
				data: { soundNotification: sound },
			},
		},
	};
}

export function setMyTelForTvSec(tel) {
	const version = getVersion(API_PATCH_TEL_FOR_TVSEC);
	const url = typeof version.path === 'function' ? version.path({ tel }) : version.path;
	return {
		type: API_PATCH_TEL_FOR_TVSEC,
		payload: {
			client: version.currentClient,
			request: {
				url: url,
				method: "PATCH",
				data: { myTelForTvSec: tel },
			},
		},
	};
}
